// src/components/GovernmentDirectorates.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { FaCheckCircle } from 'react-icons/fa';

const GovernmentDirectorates = () => {
  const directorates = [
    {
      id: 1,
      name: "Sanitary Engineering Planning & Projects Directorate",
      description: "Registered for comprehensive sewerage and drainage projects"
    },
    {
      "id": 2,
      "name": "Sanitary Engineering Operation & Maintenance Directorate",
      "description": "Responsible for the operation, maintenance, and management of sanitary engineering systems and infrastructure"
    },

    {
      id: 3,
      name: "WATER DISTRIBUTION DIRECTORATE",
      description: "Approved contractor for water distribution infrastructure"
    },
    {
      id: 4,
      name: "ELECTRICITY DIRECTORATE",
      description: "Certified for electrical infrastructure development"
    },
    {
      id: 5,
      name: "Roads Planning & Design Directorate",
      description: "Responsible for planning, designing, and overseeing road infrastructure projects"
    },
    {
      id: 6,
      name: "Roads Projects & Maintenance Directorate",
      description: "Responsible for executing and maintaining road infrastructure projects"
    }


  ];


  return (
    <section id="directorates" className="directorates-section">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="directorates-container"
        >
          <h2>Registered Government Contractors</h2>
          <p className="section-intro">
            We are registered contractors with the following government directorates
            in the Kingdom of Bahrain, ensuring compliance with all regulatory standards.
          </p>

          <div className="directorates-grid">
            {directorates.map((directorate, index) => (
              <motion.div
                key={directorate.id}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true, margin: "0px 0px -50px 0px" }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="directorate-card"
              >
                <div className="directorate-icon">
                  <FaCheckCircle />
                </div>
                <h3>{directorate.name}</h3>
                <p>{directorate.description}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default GovernmentDirectorates;